<template>
  <div class="mogujia-page">
    <div v-if="hasArchiveResult" class="mogujia-result-card">
      <div class="mogujia-result-inner">
        <div class="mogujia-result-top">
          <img class="mogujia-logo" src="/static/images/mogujia/logo.png" alt="iDoeeoD">
          <img class="mogujia-confirmed" src="/static/images/mogujia/yiqueren.png" alt="已确认">
        </div>

        <div class="mogujia-time-card">
          <div class="mogujia-time-row">
            <img class="mogujia-time-label" src="/static/images/mogujia/first.png" alt="首次确认时间">
            <span class="mogujia-time-value">{{ firstConfirmTime }}</span>
          </div>
          <div class="mogujia-time-row">
            <img class="mogujia-time-label" src="/static/images/mogujia/pre.png" alt="最近确认时间">
            <span class="mogujia-time-value">{{ latestConfirmTime }}</span>
          </div>
          <img class="mogujia-stamp" src="/static/images/mogujia/hua.png" alt="印章">
        </div>

        <div class="mogujia-result-bottom">
          <img class="mogujia-slogan" src="/static/images/mogujia/wulai.png" alt="物有来处，迹有归处">
          <img class="mogujia-desc-img" src="/static/images/mogujia/tansuo.png" alt="进入 iDoeeoD 面料档案室探索与你相遇的这块面料">

          <img
            v-if="miniAppPage"
            class="mogujia-open-btn"
            src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/kaiqi-84c4baa8cf0b4c05a8949aa8179905a3.png"
            alt="开启档案"
            @click="goToArchive"
          >
        </div>
      </div>
    </div>

    <div v-else-if="isNoArchiveResult" class="mogujia-error-card">
      <div class="mogujia-error-top">
        <img class="mogujia-error-logo" src="/static/images/mogujia/logo.png" alt="iDoeeoD">
        <img class="mogujia-error-logo-cn" src="/static/images/mogujia/logo-cn.png" alt="迹忆档案">
      </div>

      <div class="mogujia-error-divider"></div>

      <div class="mogujia-error-lock-wrap">
        <img class="mogujia-error-lock" src="/static/images/mogujia/lock.png" alt="档案锁">
      </div>

      <div class="mogujia-error-body">
        <img class="mogujia-error-tip" src="/static/images/mogujia/notfound.png" alt="暂未找到对应档案">

        <button class="mogujia-error-back" type="button" @click="goToScan">
          <img class="mogujia-error-back-img" src="/static/images/mogujia/back.png" alt="返回重新扫码">
        </button>

        <button class="mogujia-error-contact" type="button" @click="goToFollow">
          <img class="mogujia-error-contact-img" src="/static/images/mogujia/lianxi.png" alt="或联系官方协助查找">
        </button>
      </div>
    </div>

    <div v-else-if="showQueryError" class="mogujia-query-error">
      查询异常，请稍后再试
    </div>
  </div>
</template>

<script>
import { getAntiData, getInfoByCode } from '../../api/api'

export default {
  name: 'MoGuJiaResult',
  data() {
    return {
      eno: process.env.ENV_NUM === '1' ? '138225900359' : '138189391484',
      antiCode: '',
      deptId: '',
      replyCode: '',
      firstQueryTime: '',
      preQueryTime: '',
      currentQueryTime: '',
      queryError: false,
      miniAppPage: ''
    }
  },
  computed: {
    hasArchiveResult() {
      return this.replyCode === '300101' || this.replyCode === '300102'
    },
    isNoArchiveResult() {
      return this.replyCode === '300106'
    },
    showQueryError() {
      return this.queryError || (!!this.replyCode && !this.hasArchiveResult && !this.isNoArchiveResult)
    },
    firstConfirmTime() {
      return this.formatDisplayTime(this.firstQueryTime)
    },
    latestConfirmTime() {
      return this.formatDisplayTime(this.currentQueryTime)
    }
  },
  mounted() {
    this.initResult()
  },
  methods: {
    formatDisplayTime(value) {
      if (!value) {
        return ''
      }

      const match = String(value).match(/^(\d{4})[-/]?(\d{2})[-/]?(\d{2})\s+(\d{2}:\d{2}:\d{2})$/)
      if (!match) {
        return value
      }

      const [, year, month, day, time] = match
      return `${year}${month}${day} ${time}`
    },
    getCurrentTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hour = String(now.getHours()).padStart(2, '0')
      const minute = String(now.getMinutes()).padStart(2, '0')
      const second = String(now.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
    async initResult() {
      this.antiCode = String(this.$route.query.c || '').replace(/\D/g, '').slice(0, 16)

      if (!this.antiCode) {
        this.queryError = true
        return
      }

      try {
        const res = await getAntiData(this.antiCode, this.eno)
        const result = res.data || {}
        const resultData = result.data || {}

        this.replyCode = resultData.replyCode || result.replyCode || result.code || ''
        this.firstQueryTime = resultData.firstQueryTime || ''
        this.preQueryTime = resultData.preQueryTime || ''
        this.currentQueryTime = this.getCurrentTime()
        this.deptId = resultData.deptId || ''

        if (this.antiCode) {
          await this.initMiniProgramConfig()
        }
      } catch (err) {
        this.queryError = true
        console.error('蘑菇家结果页防伪查询失败:', err)
      }
    },
    async initMiniProgramConfig() {
      try {
        const res = await getInfoByCode(this.antiCode)
        const codeInfo = res && res.data && res.data.data ? res.data.data : null
        this.miniAppPage = codeInfo && codeInfo.f10 ? codeInfo.f10 : ''
      } catch (err) {
        this.miniAppPage = ''
        console.error('蘑菇家结果页码信息查询失败:', err)
      }
    },
    goToArchive() {
      if (!this.miniAppPage) {
        return
      }

      window.location.href = this.miniAppPage
    },
    goToFollow() {
      this.$router.push({
        path: '/mogujia/follow'
      })
    },
    goToScan() {
      const targetUrl = new URL('/mogujia/scan', window.location.origin)
      window.location.href = targetUrl.toString()
    }
  }
}
</script>

<style scoped>
.mogujia-page {
  min-height: 100vh;
  min-height: 100dvh;
  height: 100vh;
  height: 100dvh;
  padding: 24px 22px;
  box-sizing: border-box;
  overflow: hidden;
  background: url('/static/images/mogujia/bg.png') center center / cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.mogujia-result-card {
  width: 85.5%;
  max-width: 456px;
  height: 58vh;
  height: 58dvh;
  max-height: 720px;
  margin-top: -14px;
  padding: clamp(12px, 3vw, 18px);
  box-sizing: border-box;
  background: #fcfbf9;
  box-shadow: 0 12px 32px rgba(86, 59, 35, 0.12);
}

.mogujia-result-inner {
  position: relative;
  width: 100%;
  height: 100%;
  border: 4px solid #9f6f48;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mogujia-result-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 16%;
}

.mogujia-logo {
  width: clamp(74px, 17.8vw, 100px);
  display: block;
}

.mogujia-confirmed {
  width: clamp(62px, 15.5vw, 84px);
  margin-top: 40px;
  display: block;
}

.mogujia-time-card {
  position: relative;
  z-index: 2;
  margin-top: 8px;
  width: clamp(136px, 36vw, 166px);
  border: 1.3px solid #000;
  background: rgba(255, 255, 255, 0.14);
  box-sizing: border-box;
}

.mogujia-time-row {
  height: 20px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.mogujia-time-row + .mogujia-time-row {
  border-top: 1px solid #000;
}

.mogujia-time-label {
  width: auto;
  height: 10px;
  margin-left: 5px;
  display: block;
  flex-shrink: 0;
}

.mogujia-time-value {
  flex: 1;
  min-width: 0;
  padding-right: 5px;
  color: #bdb6ac;
  font-size: 9px;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
}

.mogujia-stamp {
  position: absolute;
  right: clamp(-34px, -7.8vw, -24px);
  bottom: clamp(-52px, -11vw, -36px);
  width: clamp(42px, 11vw, 58px);
  transform: rotate(16deg);
  pointer-events: none;
}

.mogujia-result-bottom {
  margin-top: 84px;
  padding-bottom: 14%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mogujia-slogan {
  width: clamp(102px, 26vw, 138px);
  margin-top: 0;
  display: block;
}

.mogujia-desc-img {
  width: clamp(88px, 23vw, 122px);
  margin-top: 16px;
  display: block;
}

.mogujia-open-btn {
  margin-top: 46px;
  display: block;
  width: clamp(86px, 23vw, 117px);
  height: auto;
  cursor: pointer;
}

.mogujia-error-card {
  position: relative;
  width: 85.5%;
  max-width: 456px;
  height: 59vh;
  height: 59dvh;
  max-height: 620px;
  margin: 0 auto;
  transform: translateY(-2.5%);
  border-radius: 8px;
  background: rgb(243, 239, 230);
  box-shadow: 0 12px 32px rgba(86, 59, 35, 0.12);
  overflow: hidden;
}

.mogujia-error-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: min(3.8vh, 36px);
  padding-top: min(3.8dvh, 36px);
}

.mogujia-error-logo {
  width: clamp(66px, 15.8vw, 84px);
  display: block;
}

.mogujia-error-logo-cn {
  width: clamp(70px, 16.6vw, 88px);
  margin-top: 4px;
  display: block;
}

.mogujia-error-divider {
  position: absolute;
  top: min(17.536vh, 167px);
  top: min(17.536dvh, 167px);
  left: 0;
  width: 100%;
  height: 8px;
  background: linear-gradient(
    to bottom,
    rgba(183, 175, 164, 0.12) 0%,
    rgba(183, 175, 164, 0.06) 22%,
    rgba(243, 239, 230, 0) 100%
  );
  z-index: 1;
  pointer-events: none;
}

.mogujia-error-divider::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: rgba(174, 165, 151, 0.24);
  filter: blur(0.8px);
  transform: scaleY(0.8);
  transform-origin: center top;
  opacity: 0.8;
}

.mogujia-error-divider::after {
  content: '';
  position: absolute;
  top: 1px;
  left: 0;
  width: 100%;
  height: clamp(10px, 2.45vw, 15px);
  background: linear-gradient(
    to bottom,
    rgba(154, 141, 125, 0.055) 0%,
    rgba(166, 154, 139, 0.04) 28%,
    rgba(182, 171, 156, 0.018) 58%,
    rgba(196, 187, 174, 0.008) 80%,
    rgba(243, 239, 230, 0) 100%
  );
  filter: blur(1.2px);
  pointer-events: none;
}

.mogujia-error-lock-wrap {
  position: absolute;
  top: calc(min(17.536vh, 167px) - clamp(54px, 10vw, 64px));
  top: calc(min(17.536dvh, 167px) - clamp(54px, 10vw, 64px));
  left: 45.5%;
  width: clamp(78px, 16vw, 92px);
  height: clamp(108px, 22vw, 128px);
  z-index: 2;
  cursor: pointer;
}

.mogujia-error-lock {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.mogujia-error-body {
  position: absolute;
  left: 0;
  right: 0;
  top: 54%;
  bottom: 7%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0 24px;
  box-sizing: border-box;
}

.mogujia-error-tip {
  width: clamp(120px, 31.5vw, 158px);
  margin-top: 10px;
  display: block;
  transform: scaleY(1.04);
  transform-origin: center top;
}

.mogujia-error-back {
  margin-top: 15px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.mogujia-error-back-img {
  width: clamp(23px, 6.1vw, 27px);
  display: block;
}

.mogujia-error-contact {
  margin-top: 60px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.mogujia-error-contact-img {
  width: clamp(85px, 22.2vw, 100px);
  display: block;
}

.mogujia-query-error {
  color: #6a5e51;
  font-size: 15px;
  line-height: 1.7;
  text-align: center;
}

@media (max-width: 480px) {
  .mogujia-page {
    padding: 18px 14px;
  }

  .mogujia-result-card {
    width: 85.5%;
    height: 59vh;
    height: 59dvh;
    margin-top: -10px;
    padding: 10px;
  }

  .mogujia-result-inner {
    border-width: 3px;
  }

  .mogujia-result-top {
    padding-top: 15%;
  }

  .mogujia-logo {
    width: clamp(66px, 20.8vw, 80px);
  }

  .mogujia-confirmed {
    width: clamp(56px, 17.5vw, 72px);
    margin-top: 30px;
  }

  .mogujia-time-card {
    width: clamp(130px, 41vw, 156px);
    margin-top: 8px;
  }

  .mogujia-time-row {
    height: 17px;
  }

  .mogujia-time-label {
    height: 9px;
    margin-left: 5px;
  }

  .mogujia-time-value {
    padding-right: 5px;
    font-size: 8px;
  }

  .mogujia-stamp {
    right: -24px;
    bottom: -34px;
    width: clamp(38px, 12vw, 48px);
  }

  .mogujia-result-bottom {
    margin-top: 70px;
    padding-bottom: 12%;
  }

  .mogujia-slogan {
    width: clamp(94px, 29vw, 122px);
    margin-top: 0;
  }

  .mogujia-desc-img {
    width: clamp(84px, 26vw, 108px);
    margin-top: 12px;
  }

  .mogujia-open-btn {
    margin-top: 36px;
    width: clamp(81px, 21.5vw, 106px);
  }

  .mogujia-error-card {
    width: 85.5%;
    height: 57vh;
    height: 57dvh;
    margin-top: 0;
    transform: translateY(-2.5%);
    border-radius: 8px;
  }




  .mogujia-error-top {
    padding-top: min(4.6vh, 42px);
    padding-top: min(4.6dvh, 42px);
  }

  .mogujia-error-logo {
    width: clamp(64px, 19vw, 76px);
  }

  .mogujia-error-logo-cn {
    width: clamp(68px, 20vw, 80px);
  }

  .mogujia-error-divider {
    top: min(17.424vh, 161px);
    top: min(17.424dvh, 161px);
  }

  .mogujia-error-divider::after {
    height: clamp(8px, 2.8vw, 13px);
  }

  .mogujia-error-lock-wrap {
    top: calc(min(17.424vh, 161px) - 58px);
    top: calc(min(17.424dvh, 161px) - 58px);
    left: 45.5%;
    width: clamp(72px, 21vw, 84px);
    height: clamp(104px, 30vw, 118px);
  }

  .mogujia-error-body {
    top: 53%;
    bottom: 6%;
    padding: 0 18px;
  }

  .mogujia-error-tip {
    width: clamp(116px, 37vw, 148px);
    margin-top: 8px;
  }

  .mogujia-error-back {
    margin-top: 15px;
  }

  .mogujia-error-contact {
    margin-top: 60px;
  }

  .mogujia-error-contact-img {
    width: clamp(78px, 24.6vw, 91px);
  }
}

@media (max-height: 580px) {
  .mogujia-page {
    padding: 12px;
  }

  .mogujia-result-card {
    width: 88.35%;
    height: 64vh;
    height: 64dvh;
    margin-top: -8px;
    padding: 8px;
  }

  .mogujia-result-top {
    padding-top: 9%;
  }

  .mogujia-logo {
    width: clamp(60px, 18.8vw, 70px);
  }

  .mogujia-confirmed {
    width: clamp(50px, 16vw, 62px);
    margin-top: 24px;
  }

  .mogujia-time-card {
    width: clamp(124px, 40vw, 148px);
    margin-top: 8px;
  }

  .mogujia-time-row {
    height: 15px;
  }

  .mogujia-time-label {
    height: 8px;
  }

  .mogujia-time-value {
    font-size: 7px;
  }

  .mogujia-stamp {
    right: -20px;
    bottom: -28px;
    width: clamp(34px, 11vw, 44px);
  }

  .mogujia-result-bottom {
    margin-top: 56px;
    padding-bottom: 9%;
  }

  .mogujia-slogan {
    width: clamp(88px, 28vw, 112px);
    margin-top: 0;
  }

  .mogujia-desc-img {
    width: clamp(80px, 26vw, 102px);
    margin-top: 10px;
  }

  .mogujia-open-btn {
    margin-top: 26px;
    width: clamp(75px, 19.8vw, 90px);
  }

  .mogujia-error-card {
    width: 88.35%;
    height: 63vh;
    height: 63dvh;
    margin-top: 0;
    transform: translateY(-2.5%);
    border-radius: 8px;
  }




  .mogujia-error-top {
    padding-top: min(3.2vh, 28px);
    padding-top: min(3.2dvh, 28px);
  }

  .mogujia-error-logo {
    width: clamp(58px, 18vw, 70px);
  }

  .mogujia-error-logo-cn {
    width: clamp(62px, 19vw, 74px);
  }

  .mogujia-error-divider {
    top: min(18.072vh, 153px);
    top: min(18.072dvh, 153px);
  }

  .mogujia-error-divider::after {
    height: clamp(7px, 2.2vw, 10px);
  }

  .mogujia-error-lock-wrap {
    top: calc(min(18.072vh, 153px) - 52px);
    top: calc(min(18.072dvh, 153px) - 52px);
    left: 45.5%;
    width: clamp(68px, 20vw, 76px);
    height: clamp(92px, 28vw, 106px);
  }

  .mogujia-error-body {
    top: 49%;
    bottom: 4%;
    padding: 0 14px;
  }

  .mogujia-error-tip {
    width: clamp(110px, 34.5vw, 138px);
    margin-top: 6px;
  }

  .mogujia-error-back {
    margin-top: 15px;
  }

  .mogujia-error-contact {
    margin-top: 60px;
    margin-bottom: 0;
  }

  .mogujia-error-contact-img {
    width: clamp(73px, 22.2vw, 84px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MoGuJia/Result.vue